/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Transcript_NoteInputs */



/**
* | output |
* | --- |
* | "Transcribed automatically, may contain small mistakes." |
*
* @param {Practice_Transcript_NoteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_transcript_note = /** @type {((inputs?: Practice_Transcript_NoteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Transcript_NoteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Automatisch uitgeschreven, kan kleine fouten bevatten.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcrit automatiquement, peut contenir de petites erreurs.")
	return /** @type {LocalizedString} */ ("Transcribed automatically, may contain small mistakes.")
});